import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Particles from "react-tsparticles";
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import img2 from "../../img/Group-26.png"
import img3 from "../../img/Group-31.png"
import img4 from "../../img/Path-25.png"
import img6 from "../../img/Rectangle-7.png"
import img7 from "../../img/farid_n-removebg-preview.png"
AOS.init();

const Hero = () => {
    const particlesInit = (main) => {
    };
    const particlesLoaded = (container) => {
    };

    return (
        <section className='hero-section'>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    height: "100px",
                    fpsLimit: 60,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "bubble",
                            },
                            onHover: {
                                enable: true,
                                mode: "bounce",
                                parallax: {
                                    enable: true
                                }
                            },
                            resize: true,
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 100,
                            enable: true,
                            opacity: 0.5,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            direction: "none",
                            enable: true,
                            outMode: "bounce",
                            random: false,
                            speed: 3,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 50,
                        },
                        opacity: {
                            value: 0.5,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            random: true,
                            value: 1,
                        },
                    },
                    detectRetina: true,
                }}
            />
            <Container className='h-100 position-relative overflow-hidden '>
                <img src={img2} className='img img2' alt="" />
                <img src={img2} className='img img7' alt="" />
                <img src={img3} className='img img3' alt="" />
                <img src={img3} className='img img8' alt="" />
                <img src={img4} className='img img4' alt="" />
                <img src={img4} className='img img5' alt="" />
                <img src={img4} className='img img51' alt="" />
                <img src={img4} className='img img52' alt="" />
                <img src={img4} className='img img53' alt="" />
                <img src={img4} className='img img54' alt="" />
                <img src={img6} className='img img6' alt="" />
                <Row xs={1} md={2} className='flex-wrap-reverse flex-sm-wrap-reverse flex-xs-wrap-reverse   h-100 align-items-center'>
                    <Col>
                        <div className="hero  text-center text-md-start my-3 my-md-0">
                            <h4 >Hello, I'm</h4>
                            <h1>Md. Farid <br />
                                Hossain Jibon</h1>
                            <p>Web Designer & Developer</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="hero-img text-md-end text-center">
                            <img className='img-fluid w-100' src="https://i.ibb.co/7RRc9DS/pash-blue-removebg-preview-1.png" alt="" />
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <hr style={{ color: "#fff", height: "2px" }} /> */}
        </section>

    );

};

export default Hero;